export default __webpack_public_path__ + "static/media/promocode_pc_En.d85e3217.webp";